
import "../styles/home/Section2.css";

const Section2Sight = () => {
  return (
    <section
      className="htmlblock"

      style={{minHeight: "0px"}}
    >
      <div className="container">
        <div className="row">
          <div className="col-md-5">
            <h2 style={{margin: "0", color: "#fff"}}>Amazing things to see in Toronto</h2>
          </div>
         
        </div>
      </div>
    </section>
  );
};

export default Section2Sight;
